import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#1976D2',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                background: '#FAFAFA',
                surface: '#FFFFFF',
                onPrimary: '#FFFFFF',
                onSecondary: '#FFFFFF',
                onBackground: '#000000',
                onSurface: '#000000',
                onError: '#FFFFFF',
                blue: '#2196F3',
                indigo: '#3F51B5',
                purple: '#9C27B0',
                pink: '#E91E63',
                red: '#F44336',
                orange: '#FF9800',
                yellow: '#FFEB3B',
                green: '#4CAF50',
                teal: '#009688',
                cyan: '#00BCD4'
            },
            dark: {
                primary: '#2196F3',
                secondary: '#424242',
                accent: '#FF4081',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FB8C00',
                background: '#121212',
                surface: '#1E1E1E',
                onPrimary: '#FFFFFF',
                onSecondary: '#FFFFFF',
                onBackground: '#FFFFFF',
                onSurface: '#FFFFFF',
                onError: '#000000',
                blue: '#42A5F5',
                indigo: '#5C6BC0',
                purple: '#AB47BC',
                pink: '#EC407A',
                red: '#EF5350',
                orange: '#FFA726',
                yellow: '#FFEE58',
                green: '#66BB6A',
                teal: '#26A69A',
                cyan: '#26C6DA'
            }
        }
    }
});
